import React, { memo } from 'react';

const Select = memo(({ 
  label,
  value,
  onChange,
  options = [],
  placeholder = 'Select an option',
  disabled = false,
  error,
  className = '',
  style = {},
  size = 'medium',
  ...props 
}) => {
  const baseStyles = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    backgroundColor: disabled ? '#f9fafb' : 'white',
    color: disabled ? '#9ca3af' : '#374151',
    transition: 'all 0.2s ease',
    outline: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    ...style
  };

  const sizes = {
    small: {
      padding: '4px 8px',
      fontSize: '12px',
      minHeight: '28px'
    },
    medium: {
      padding: '6px 12px',
      fontSize: '14px',
      minHeight: '36px'
    },
    large: {
      padding: '8px 16px',
      fontSize: '16px',
      minHeight: '44px'
    }
  };

  const selectStyles = {
    ...baseStyles,
    ...sizes[size],
    borderColor: error ? '#dc2626' : '#d1d5db',
    '&:focus': {
      borderColor: error ? '#dc2626' : '#3b82f6',
      boxShadow: error ? '0 0 0 3px rgba(220, 38, 38, 0.1)' : '0 0 0 3px rgba(59, 130, 246, 0.1)'
    }
  };

  return (
    <div className={`select-wrapper ${className}`} style={{ marginBottom: '8px' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '12px',
          fontWeight: '500',
          color: '#374151',
          marginBottom: '4px'
        }}>
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={selectStyles}
        {...props}
      >
        {placeholder && (
          <option value="">{placeholder}</option>
        )}
        {options.map((option) => (
          <option 
            key={option.value || option} 
            value={option.value || option}
          >
            {option.label || option}
          </option>
        ))}
      </select>
      {error && (
        <div style={{
          fontSize: '12px',
          color: '#dc2626',
          marginTop: '4px'
        }}>
          {error}
        </div>
      )}
    </div>
  );
});

export default Select;

Select.displayName = 'Select';
